export const DEFAULT_COLLAPSED_WIDTH = 356;
export const DEFAULT_EXPANDED_WIDTH = 928;
